import React from "react";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import { isLogin } from "src/app-redux/auth/authSlice";
import { useAppSelector } from "src/app-redux/hooks";
import { RouteGuard } from "src/modules/auth/components/RouteGuard";
import { ROUTES } from "./routes";

export function AppRouting() {
  const user = useAppSelector(isLogin);

  return (
    <BrowserRouter>
      <Switch>
        {ROUTES.map((route, i) => (
          <Route key={i} path={route.path}>
            {route.guard ? (
              <RouteGuard path={route.path} redirectPath="/auth">
                {<route.component />}
              </RouteGuard>
            ) : (
              <route.component />
            )}
          </Route>
        ))}
        {user ? (
          <Redirect to={{ pathname: "/work-order" }} />
        ) : (
          <Redirect to={{ pathname: "/auth/login" }} />
        )}
      </Switch>
    </BrowserRouter>
  );
}
